/**
 * Where a ProvisionAgentTransactionType may be used: only by the engine, only manually, or both
 * (bm CustomerBillingTransactionType mirror, PAT §A.2).
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionTransactionTypeUsecase}. The backend
 * persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match
 * the backend exactly and new constants MUST only be appended at the end — never inserted between
 * existing ones, which would silently re-map every stored value (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionTransactionTypeUsecase {

    SYSTEM,
    MANUAL,
    MIXED
}
